import React from 'react';
import Instagram from '../Links/Instagram';
import GoogleDrive from '../Links/GoogleDrive';
import Youtube from '../Links/Youtube';
import Whatsapp from '../Links/Whatsapp';

import * as S from './styles';

function Footer() {
  return (
    <S.FooterDiv>
      <S.Logo />
      <section>
        <p>(31) 99853-3003</p>
        <p>travessias.psicanalise@gmail.com</p>
        <p>Rua Levindo Lopes, 333 - 1401. CEP 30140-170. Belo Horizonte - MG</p>
      </section>
      <div>
        <Instagram />
        <Whatsapp />
        {/* <Youtube /> */}
      </div>
    </S.FooterDiv>
  );
}

export default Footer;
